import { render } from "./CreateHousePage.vue?vue&type=template&id=2cbd9aa7&ts=true"
import script from "./CreateHousePage.vue?vue&type=script&lang=ts"
export * from "./CreateHousePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__